<div class="footer">
    © Copyright 2021 <a href="https://github.com/chachir">chachir</a> & <a
        href="https://github.com/Alejandro-Leiva">Alejandro-Leiva</a>. All rights reserved.
</div>